export default {
    DEFAULT_SCHEDULER_LOCATION: {
        1594: 0
    }
}